import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { IMAGE } from 'common/endpoints'

import StyledSiteLogo from './StyledSiteLogo'

const props = external => (external ? { as: 'a', href: '/' } : { as: Link, to: '/' })

const SiteLogo = ({ logoName, siteName, external }) => (
  <StyledSiteLogo {...props(external)} className="logo">
    {logoName ? (
      <img src={IMAGE.basic(logoName)} />
    ) : (
      <h1 className="text">
        {siteName}
        <sup>&trade;</sup>
      </h1>
    )}
  </StyledSiteLogo>
)

export default connect(p => p.siteConfig)(SiteLogo)
